import React, { SVGProps } from 'react';

export default ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 17.6667L7.7904 26L22 2" stroke="currentColor" strokeWidth="4" />
  </svg>
);
